import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EndPointsService {

  isLocal = false;
  private _baseUrl: string;
  constructor() {
    if (this.isLocal) {
      this._baseUrl = "http://localhost/savantrx-web-tomcat/";
    } else {
      this._baseUrl = "";
    }
  }

  private common = "common/";
  private messages = "messages";
  private planDetailsURL = "url/plandetails/randomuuid";
  private fetchReportURL = "url/fetchpdfreport/planid/";
  private fetchExternalPDFReportURL = "url/fetchexternalpdfreport/planid/";
  private searchByDrugNameURL = "drugsearch/searchbydrug/value/";
  private coverageDetailsUrl = "drugsearch/drugsearchdata";
  private nonFormularyDrugDetailsUrl = "drugsearch/nonformularydrugs";
  private drugSearchDetailDataUrl = "drugsearch/drugsearchdetail/detail";
  private alternativesURL = "drugsearch/alternatives";
  private tccCategoryDetailsURL = "drugsearch/class/gettcccategorydetails/package";
  private tccClassDetailsURL = "drugsearch/class/gettccClassDetails/group";
  private searchByTCCClassURL = "drugsearch/class/searchByDrugClass";
  private searchDrugsURL = "drugsearch/searchdrug/value/";

  getMessages() {
    return `${this._baseUrl}${this.common}${this.messages}`;
  }

  getPlanDetails(randomUUID: string) {
    return `${this._baseUrl}${this.planDetailsURL}` + "/" + randomUUID;
  }

  getTCCCategoryDetails(packageId: number) {
    return `${this._baseUrl}${this.tccCategoryDetailsURL}` + "/" + packageId;
  }

  getTCCClassDetails(groupId: number, category: string) {
    return `${this._baseUrl}${this.tccClassDetailsURL}` + "/" + groupId + "/category/"+btoa(category);
  }

  searchByTCCClass() {
    return `${this._baseUrl}${this.searchByTCCClassURL}`;
  }

  getAlternatives() {
    return `${this._baseUrl}${this.alternativesURL}`;
  }

  searchByDrugName(value:string) {
    return `${this._baseUrl}${this.searchByDrugNameURL}`+value;
  }

  fetchPDFReport(planId: number, reportType: string) {
    return `${this._baseUrl}${this.fetchReportURL}` + planId + "/reporttype/" + reportType;
  }

  fetchExternalPDFReport(planId: number, externalPDF: string) {
    return `${this._baseUrl}${this.fetchExternalPDFReportURL}` + planId + "/externalPDF/" + externalPDF;
  }

  getCoverageDetails() {
    return `${this._baseUrl}${this.coverageDetailsUrl}`;
  }

  getNonFormularyDrugDetails() {
    return `${this._baseUrl}${this.nonFormularyDrugDetailsUrl}`;
  }

  getDrugSearchDetailData() {
    return `${this._baseUrl}${this.drugSearchDetailDataUrl}`;
  }

  searchDrugs(value:string) {
    return `${this._baseUrl}${this.searchDrugsURL}`+value;
  }

}
